export default class Print {

    public static printContents(data: any, heading: string, iFrame: any) {
        console.log('printContentsData', data);
        if ( iFrame !== null) {
            let pri: any = iFrame.contentWindow;
            pri.document.open();
            // tslint:disable-next-line:max-line-length
            pri.document.write('<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">');
            pri.document.write('<body><div style="margin-left:50px; margin-right:50px">');
            pri.document.write('<div className="page-header"><h1>' + heading + '</h1></div><div className="row"><div>');
            pri.document.write(Print.json2table(data, 'table table-bordered table-striped', true));
            pri.document.write('</div></div>');
            pri.document.write('<script>window.onload = function() { window.focus(); window.print(); }</script>');
            pri.document.write('</body>');
            pri.document.close();
            pri.focus();
            // pri.print();
        }
    }

    private static json2table(json: any, classes: string, reqSerial: boolean = false) {
        if (json === undefined) {
            return '';
        }
        console.log(json.length);
        var cols = Object.keys(json[0]);
       
        var headerRow = '';
        var bodyRows = '';
       
        classes = classes || '';
     
        function capitalizeFirstLetter(str: string) {
          str = str.split('_').join(' ') ; 
          return str.charAt(0).toUpperCase() + str.slice(1);
        }
       
        if (reqSerial) {
         headerRow += '<th>#</th>';
        }
        cols.map(function(col: any) {
         if ( !(json[0][col] instanceof Array)) {
              headerRow += '<th>' + capitalizeFirstLetter(col) + '</th>';
          }
        });
       
        var count = 0;
        json.map(function(row: any) {
          count++;
          bodyRows += '<tr>';
          if ( reqSerial ) {
              bodyRows += '<th scope="row">' + count + '</th>';
          }
         
          cols.map((colName: string) => {
            if (row[colName] instanceof Array) {
                // tslint:disable-next-line:max-line-length
                bodyRows += '</tr><tr><td colspan="' + cols.length + (reqSerial ? 1 : 0 ) + '" style="padding-left:63px;">';
                bodyRows += '<h4>' + capitalizeFirstLetter(colName) + '</h4>';
                bodyRows += '<div>';
                if (row[colName].length > 0) {
                    bodyRows += Print.json2table( row[colName], classes, false );
                } else {
                    bodyRows += '<h5> No Data Found </h5>';
                }
                bodyRows += '<div>';
                bodyRows += '</td>';
            } else {
            bodyRows += '<td>' + row[colName] + '</td>';
            }    
          });
     
          bodyRows += '</tr>';
        });
     
        console.log( headerRow );
        console.log( bodyRows );
        return '<table class="' +
               classes +
               '"><thead><tr class="info">' +
               headerRow +
               '</tr></thead><tbody>' +
               bodyRows +
               '</tbody></table>';
    }
 
}


// WEBPACK FOOTER //
// ./src/components/common/print.tsx